export default __webpack_public_path__ + "static/media/info.9b104f39.png";